import * as actionTypes from 'ActionTypes';
import { isSameTrackAndPlaying } from 'Utils';

export const setActiveTrackId = (activeTrackId) => {
	return {
		type: actionTypes.SET_ACTIVE_TRACK_ID,
		activeTrackId
	};
};

export const setActiveTrack = (activeTrack) => {
	return {
		type: actionTypes.SET_ACTIVE_TRACK,
		activeTrack
	};
};

export const setDuration = (duration) => {
	return {
		type: actionTypes.SET_DURATION,
		duration
	};
};

export const setInPlaylist = (playlist) => {
	return {
		type: actionTypes.SET_IN_PLAYLIST,
		playlist
	};
};

export const togglePlaying = (isPlaying) => {
	return {
		type: actionTypes.SET_IS_PLAYING,
		isPlaying
	};
};

export const setIsReady = (isReady) => {
	return {
		type: actionTypes.SET_READY_STATE,
		isReady
	};
};

// export const setTrackInPlaylist = (trackId) => {
// 	return {
// 		type: actionTypes.SET_TRACK_IN_PLAYLIST,
// 		trackId
// 	};
// }

export const removeFromPlaylist = (trackId) => {
	return {
		type: actionTypes.REMOVE_TRACK_FROM_PLAYLIST,
		trackId
	};
};

export const deactivateTrack = () => {
	return {
		type: actionTypes.RESET_ACTIVE_TRACK
	};
};

export const emptyPlaylist = () => {
	return {
		type: actionTypes.RESET_PLAYLIST
	};
};

export const setProgressLoaded = (progressLoaded) => {
	return {
		type: actionTypes.SET_PROGRESS_LOADED,
		progressLoaded
	};
};

export const setProgressCompleted = (progressCompleted) => {
	return {
		type: actionTypes.SET_PROGRESS_COMPLETED,
		progressCompleted
	};
};

export const isSameTrack = (song) => (dispatch, state) => {
	return state().player.activeTrackId === song.file_id;
};

export const onPlayPause = (song) => (dispatch, state) => {
	const player = state().player;
	const trackId = song?.file_id;
	const activeTrackId = player.activeTrackId;
	const isCurrentlyPlaying = player.isPlaying;
	const isPlaying = isSameTrackAndPlaying(
		activeTrackId,
		trackId,
		isCurrentlyPlaying
	);
	if (player.activeTrackId !== trackId && !isPlaying) {
		dispatch(setDuration(0));
		dispatch(setIsReady(false));
		dispatch(setProgressLoaded(0));
		dispatch(setProgressCompleted(0));
		dispatch(setActiveTrack(song));
	}
	dispatch(togglePlaying(!isPlaying));
	dispatch(setActiveTrackId(trackId));
};

export const onEndPlayer = () => (dispatch) => {
	dispatch(togglePlaying(false));
	dispatch(setIsReady(false));
	dispatch(setProgressCompleted(0));
	dispatch(setProgressLoaded(0));
};

export const resetPlayer = () => (dispatch) => {
	dispatch(togglePlaying(false));
	dispatch(setIsReady(false));
	dispatch(setActiveTrack(null));
	dispatch(setActiveTrackId(null));
	dispatch(setProgressCompleted(0));
	dispatch(setProgressLoaded(0));
};
